// extracted by mini-css-extract-plugin
module.exports = {"options":"VoteForm_options__2a9Pn","option":"VoteForm_option__3cuol","active":"VoteForm_active__3Y_lI"};